import React, { useEffect, useRef } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Button, DialogActions, IconButton, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';

type Props = {
  apiKey: string;
  onClose: () => void;
};

export const ApiKeysDialog: React.FC<Props> = ({ apiKey, onClose }) => {
  const descriptionElementRef = useRef<HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const { current: descriptionElement } = descriptionElementRef;
    if (descriptionElement !== null) {
      descriptionElement.focus();
    }
  }, []);

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="api-keys-title"
      aria-describedby="api-keys-description"
    >
      <DialogTitle id="api-keys-title" align="center">
        Сохраните сгенерированный Api Key
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText id="api-keys-description" ref={descriptionElementRef} tabIndex={-1}>
          После закрытия ключ нельзя будет восстановить
        </DialogContentText>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
          <Box
            role="textbox"
            aria-label="Api Key"
            sx={{
              flex: 1,
              px: 1.5,
              py: 1,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              bgcolor: 'background.paper',
              fontFamily:
                'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
              whiteSpace: 'nowrap',
              overflowX: 'auto',
              userSelect: 'text',
            }}
          >
            {apiKey}
          </Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<ContentCopyIcon />}
            onClick={() => {
              if (!apiKey) return;
              navigator.clipboard?.writeText(apiKey);
              enqueueSnackbar('Ключ скопирован', { variant: 'success' });
            }}
            aria-label="Скопировать ключ"
          >
            Копировать
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant="outlined" onClick={onClose}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};
